/* global Word */
import { GAP_PARA_FONT_SIZE_PT } from '../../core/config/constants';

/** ParagraphBuilder — helpers for Word.Paragraph operations */
export class ParagraphBuilder {
  public static collapseToMinHeight(para: Word.Paragraph): void {
    para.font.size = GAP_PARA_FONT_SIZE_PT;
    para.spaceBefore = 0;
    para.spaceAfter = 0;
    para.lineUnitBefore = 0;
    para.lineUnitAfter = 0;
  }

  public static clearSpacing(para: Word.Paragraph): void {
    para.spaceBefore = 0;
    para.spaceAfter = 0;
    para.lineUnitBefore = 0;
    para.lineUnitAfter = 0;
  }

  public static insertTextRun(
    para: Word.Paragraph,
    text: string,
    opts: { fontFamily: string; fontSize: number; bold?: boolean; color: string }
  ): Word.Range {
    const run = para.insertText(text, Word.InsertLocation.start);
    run.font.name = opts.fontFamily;
    run.font.size = opts.fontSize;
    run.font.bold = !!opts.bold;
    run.font.color = opts.color;
    return run;
  }
}
